module.exports = __webpack_public_path__ + "img/2022-11.86cd6de0.jpg";